import { FC, useEffect, useState } from "react"
import { useHistory } from "react-router-dom"
import "./style/homepage.css"
import { useSelector } from "react-redux"
import { ISettingTypeState } from "src/app/modules/siteSettings/components/settings"
import { isEmpty } from "lodash"
import {
  HiUserAdd,
  HiSearch,
  HiRefresh,
  HiClipboardCheck,
  HiDocumentText,
  HiExternalLink,
} from "react-icons/hi"
import useGetMasterDataStore from "src/cms/hooks/get/masterData/usePostMasterData"

const Homepage: FC = () => {
  const { mutate } = useGetMasterDataStore()


  const navigate = useHistory()
  const [applicationName, setAplicationName] = useState('')
  const settingTypeData: ISettingTypeState = useSelector((state: any) => state.settingType)
  const module = useSelector((state: any) => state.auth?.module?.moduleData)
  useEffect(() => {
    if (!isEmpty(settingTypeData?.backendData)) {
      settingTypeData?.backendData &&
        settingTypeData?.backendData['Application Credentials']?.map((item: any) => {
          if (item?.name === 'applicationName') {
            setAplicationName(item?.value)
          }
        })
    }
  }, [settingTypeData])
  useEffect(() => {
    mutate()
  }, [])

  const moduleIconMap: Record<string, JSX.Element> = {
    "New CIF New Account": <HiUserAdd size={40} />,
    "Find Account": <HiSearch size={40} />,
    "KYC Update": <HiRefresh size={40} />,
    "KYC Update (OLD)": <HiRefresh size={40} />,
    "Account Status Check": <HiClipboardCheck size={40} />,
    "Report": <HiDocumentText size={40} />,
    "Report Count": <HiDocumentText size={40} />,
  }

  const availableModules = ["New CIF New Account", "KYC Update", "KYC Update (OLD)", "Find Account", "Account Status Check", "Report", "Report Count",]

  // const moduleMap: Record<string, any> = {}
  // module?.forEach((item: any) => {
  //   moduleMap[item.name] = item
  // })

  // Map in the same order as availableModules
  // const cards = availableModules
  //   .filter((name) => moduleMap[name]) // only include if module exists
  //   .map((name) => ({
  //     title: name,
  //     route: moduleMap[name].alias,
  //     icon: moduleIconMap[name],
  //   }))


  // Map of module name → module object
  const moduleMap: Record<string, any> = {}
  module?.forEach((item: any) => {
    moduleMap[item.name] = item
  })

  // Map cards in order, with custom route handling
  const cards = availableModules
    .map((name) => {
      if (name === "Report Count") {
        return {
          title: name,
          route: "/report", // static route
          icon: moduleIconMap[name] || moduleIconMap["Report"],
        }
      }
      if (name === "Report" && moduleMap[name]) {
        return {
          title: `${name}s`,
          route: "/account-opening-status",
          icon: moduleIconMap[name] || moduleIconMap["Report"],
        }
      }

      if (moduleMap[name]) {
        return {
          title: name,
          route: moduleMap[name].alias, // dynamic module alias
          icon: moduleIconMap[name],
        }
      }

      // Skip if module not found
      return null
    })
    .filter(Boolean) as { title: string; route: string; icon: JSX.Element }[]

  // Add Remit Tracker as an external link card
  const remitTrackerCard = {
    title: "Remit Tracker",
    route: "https://www.kumariremit.com/webtracker/websiteAPI.asmx",
    icon: <HiExternalLink size={40} />,
    isExternal: true,
  }

  // Append Remit Tracker to cards array
  cards.push(remitTrackerCard)

  return (
    <div className="homepage">
      {/* Hero Section */}
      <section className="hero">
        <h1 className="hero-title">
          <span>Welcome to {applicationName} Limited</span>
        </h1>
      </section>


      {/* Cards Section */}
      <section className="card-grid">
        {cards.map((card: any) => (
          <div
            key={card.route}
            className="home-card"
            onClick={() => card.isExternal ? window.open(card.route, '_blank', 'noopener,noreferrer') : navigate.push(card.route)}
          >
            <div className="icon">{card.icon}</div>
            <h3>{card.title}</h3>
          </div>
        ))
        }
      </section >
    </div >
  )
}

export { Homepage }